
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Training = lazy(() => import('../pages/training/page'));
const Consulting = lazy(() => import('../pages/consulting/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));
const WizeAI = lazy(() => import('../pages/wizeai/page'));
const Demo = lazy(() => import('../pages/demo/page'));
const StudentDashboard = lazy(() => import('../pages/lms/student-dashboard/page'));
const CourseCatalog = lazy(() => import('../pages/lms/course-catalog/page'));
const CoursePlayer = lazy(() => import('../pages/lms/course-player/page'));
const AdminDashboard = lazy(() => import('../pages/lms/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/training',
    element: <Training />,
  },
  {
    path: '/consulting',
    element: <Consulting />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/wizeai',
    element: <WizeAI />,
  },
  {
    path: '/demo',
    element: <Demo />,
  },
  {
    path: '/lms/student-dashboard',
    element: <StudentDashboard />,
  },
  {
    path: '/lms/course-catalog',
    element: <CourseCatalog />,
  },
  {
    path: '/lms/course/:courseId',
    element: <CoursePlayer />,
  },
  {
    path: '/lms/admin',
    element: <AdminDashboard />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
